import React from 'react'
import styles from './DashboardCountCard.module.css'
import smStyles from "./SM.module.css";
import ShimmerLoader from '../ShimmerLoader'
import { useNavigate } from 'react-router-dom';
export default function DashboardCountCard({ count, label, loading, navigateto, state }) {
  const navigate=useNavigate();
  
  return (
    <div className={smStyles.sm} onClick={()=>navigate(navigateto, {state:state})}>
       <div className={smStyles.headingParagraph}>
        <div className={smStyles.thisWeekVisitors}>{label}</div>
        {loading ? <ShimmerLoader width="3rem" /> : <b className={smStyles.b}>{count}</b>}
      </div>
    </div>
  )
}
